export enum InterestType {
    // ALL = 'All',
    PERSONAL = 'Personal',
    PROFESSIONAL = 'Professional'
}